var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearningcenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 237,
    viewBox: "0 0 237 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 118.495,
    cy: 118.495,
    r: 115.901,
    stroke: "#00AEEF",
    strokeOpacity: 0.15,
    strokeWidth: 4.8125
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 10,
    width: 227,
    height: 227
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.495,
    cy: 123.495,
    r: 113.495,
    fill: "#00AEEF"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 110.74,
    height: 109.61,
    transform: "matrix(1 0 0 -1 61.3379 172.6)",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.495 86.9902L166.426 171.74H68.5647L117.495 86.9902Z",
    fill: "#00AEEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningcenter);
export default __webpack_public_path__ + "static/media/Learning center.2816773bb2105d160375a284f370a248.svg";
export { ForwardRef as ReactComponent };